import api from "../services/api";

// Por que um atendimento acabou.
//
// A chave é o que fica gravado em `Tickets.closeReason`; o rótulo é só o que
// se lê. Os motivos que a equipe escolhe são cadastrados pelo administrador
// (Configurações › Atendimento) e vêm da API — trocar o nome de um motivo não
// pode apagar o passado, por isso o ticket guarda a chave e não o id.

// Os que só o sistema grava. Ficam aqui porque ninguém os escolhe numa tela, e
// por isso mesmo não podem sumir se o administrador mexer na lista dele. O
// espelho é `backend/src/helpers/MotivosDeEncerramento.ts`.
export const MOTIVOS_AUTOMATICOS = [
	{
		chave: "inatividade",
		rotulo: "Encerrado por inatividade",
		classe:
			"bg-orange-100 text-orange-800 dark:bg-orange-950 dark:text-orange-300",
	},
	{
		chave: "confirmado_pelo_cliente",
		rotulo: "Confirmado pelo cliente",
		classe:
			"bg-emerald-100 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-300",
	},
	{
		chave: "em_massa",
		rotulo: "Encerrado em massa",
		classe:
			"bg-violet-100 text-violet-800 dark:bg-violet-950 dark:text-violet-300",
	},
	{
		chave: "redirecionado",
		rotulo: "Seguiu para outra conexão",
		classe: "bg-cyan-100 text-cyan-800 dark:bg-cyan-950 dark:text-cyan-300",
	},
];

// Cores dos motivos cadastrados, na ordem em que aparecem. A empresa escolhe o
// texto; a cor sai daqui para os selos continuarem distinguíveis entre si sem
// obrigar o administrador a escolher paleta.
const CORES = [
	"bg-emerald-100 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-300",
	"bg-amber-100 text-amber-800 dark:bg-amber-950 dark:text-amber-300",
	"bg-sky-100 text-sky-800 dark:bg-sky-950 dark:text-sky-300",
	"bg-rose-100 text-rose-800 dark:bg-rose-950 dark:text-rose-300",
	"bg-teal-100 text-teal-800 dark:bg-teal-950 dark:text-teal-300",
	"bg-indigo-100 text-indigo-800 dark:bg-indigo-950 dark:text-indigo-300",
];

// Uma requisição por sessão, compartilhada por todo mundo que precisa do
// rótulo: os dois modais de encerramento, o selo da lista, o selo do cabeçalho
// e o filtro. Sem o cache, abrir a lista de resolvidos pediria a mesma lista
// uma vez por linha.
let promessa = null;
let cadastrados = [];

export const limparCacheDeMotivos = () => {
	promessa = null;
};

// Quem grava avisa os outros: sem isto, cadastrar um motivo em Configurações
// só apareceria na tela de encerramento depois do F5.
export const EVENTO_MOTIVOS = "motivos-de-encerramento:mudou";

export const carregarMotivosDeEncerramento = () => {
	if (!promessa) {
		promessa = api
			.get("/close-reasons")
			.then(({ data }) => {
				const lista = Array.isArray(data) ? data : [];

				cadastrados = lista.map((m, i) => ({
					chave: m.key,
					rotulo: m.name,
					ajuda: m.helpText || "",
					// A frase que a tela de encerramento sugere ao escolher este
					// motivo. Vazia = cai na da conexão.
					despedida: m.farewellMessage || "",
					classe: CORES[i % CORES.length],
				}));

				return cadastrados;
			})
			// Sem resposta, encerrar não pode travar: a lista vazia deixa o modal
			// encerrar sem motivo, que é pior do que com — mas não impede ninguém
			// de trabalhar.
			.catch(() => []);
	}

	return promessa;
};

// O que já foi carregado, para quem só precisa do rótulo e não pode esperar
// (o selo, que renderiza dentro de uma lista).
export const motivoDeEncerramento = (chave) => {
	if (!chave) return null;

	const conhecido = [...cadastrados, ...MOTIVOS_AUTOMATICOS].find(
		(m) => m.chave === chave,
	);

	// Motivo apagado da lista, ou ainda não carregado: continua legível pela
	// própria chave, em vez de virar selo em branco.
	return (
		conhecido || {
			chave,
			rotulo: chave,
			classe: "bg-muted text-muted-foreground",
		}
	);
};

export const todosOsMotivos = () => [...cadastrados, ...MOTIVOS_AUTOMATICOS];
